import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-college-b-w',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconCollegeBW {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M30.41 12.79a2.92 2.92 0 0 0 3.43-3.44c-.22-1.14-1.15-2.08-2.29-2.29a2.92 2.92 0 0 0-3.43 3.44c.22 1.14 1.15 2.08 2.29 2.29m3.06 1.18h-4.89c-.77 0-1.49.4-1.96.98 2.03 1.23 3.35 3.44 3.35 6.01v1.01h5.99l.03-5.5c0-1.33-1.19-2.5-2.53-2.5Zm-26.05 0H2.54C1.2 13.96 0 15.13 0 16.47v5.5h5.98l.04-.99c0-2.58 1.32-4.79 3.35-6.02-.47-.59-1.18-.99-1.96-.99Zm-2.98-1.18a2.92 2.92 0 0 0 3.43-3.44c-.22-1.14-1.15-2.08-2.29-2.29a2.92 2.92 0 0 0-3.43 3.44c.22 1.14 1.15 2.08 2.29 2.29m7.05 3.43c.47-.15.97-.25 1.5-.25h10c.52 0 1.01.1 1.48.25-2.03 3.94-4.47 7.17-5.21 8.11-.37-.22-.81-.36-1.28-.36s-.91.14-1.29.37c-.72-.91-3.16-4.15-5.21-8.11Zm16.48 4.74v12.05h-3v3H10.99v-3h-3V20.97c0-1.48.66-2.79 1.68-3.71 1.77 3.61 4.19 6.87 5.82 8.87l.03.03c-.01.1-.03.21-.03.32a2.5 2.5 0 0 0 5 0c0-.1-.02-.19-.03-.29v-.01c1.63-1.99 4.08-5.26 5.85-8.91 1.01.91 1.66 2.22 1.66 3.69M11.15 5.37l.12.03c.56.13 1.12.2 1.66.2 2.07 0 4.08-.86 5.52-2.36l1.6-1.58 1.37 1.36a7.68 7.68 0 0 0 3.07 2.09l.22.08-.07-.23C23.75 2.04 20.99 0 17.96 0S12 2.16 11.2 5.25l-.03.11Zm-.18 2.06v.16c.31 3.6 3.38 6.41 6.97 6.41s6.75-2.89 6.97-6.58v-.1l-.65-.13a9.545 9.545 0 0 1-4.15-2.77l-.09-.1-.09.1c-1.79 2.06-4.36 3.24-7.02 3.24-.59 0-1.19-.07-1.8-.19l-.15-.03Z"/>
</svg>

    );
  }
}
